import { useMemo } from 'react';
import { filterHubItems } from './filterHubItems';
import { useHubSearchQuery } from './useHubSearchQuery';
import { usePaginatedItems } from './usePaginatedItems';

const PAGE_SIZE = 9;

export function useFilteredHubListing(items) {
  const query = useHubSearchQuery();
  const hasQuery = Boolean(query);
  const filtered = useMemo(() => filterHubItems(items, query), [items, query]);

  const firstItem = hasQuery ? null : filtered[0];
  const listItems = useMemo(
    () => (hasQuery ? filtered : filtered.slice(1)),
    [filtered, hasQuery]
  );
  const pagination = usePaginatedItems(listItems, PAGE_SIZE);

  return {
    query,
    hasQuery,
    matchCount: filtered.length,
    firstItem,
    ...pagination,
  };
}
